import request from '../http/index'

/**********数据管理->基础档案管理->经销商->平台业务分析调整**********/

/**
 *
 * @param {*} data
 * @returns 列表
 */
export async function OrgStockMoneyChangeAdjustList(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/List", data);
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 详情
 */
export async function OrgStockMoneyChangeAdjustInfo(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/Info", data);
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 新增
 */
export async function OrgStockMoneyChangeAdjustAdd(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/Add", data);
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 修改
 */
export async function OrgStockMoneyChangeAdjustEdit(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/Edit", data);
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 删除
 */
export async function OrgStockMoneyChangeAdjustDelete(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/Delete", data);
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导出
 */
export async function OrgStockMoneyChangeAdjustExport(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/Export", data, {
        responseType: "blob",
    });
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导入模板下载
 */
export async function OrgStockMoneyChangeAdjustDownloadTemplet(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/DownloadTemplet", data);
    return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导入
 */
export async function OrgStockMoneyChangeAdjustImport(data = {}) {
    const res = await request.post("/api/ba/OrgStockMoneyChangeAdjust/Import", data);
    return res.data;
}
